import { ElementType, IElementData } from "@pageBuilder/typings";
import { CascadeRendererBase } from "./cascade-renderer-base";
import { MainSectionsAreaCascadeRenderer } from "src/sections-areas/cascade-renderers/main-sections-area-cascade-renderer";
import { HeaderSectionsAreaCascadeRenderer } from "src/sections-areas/cascade-renderers/header-sections-area-cascade-renderer";
import { FooterSectionsAreaCascadeRenderer } from "src/sections-areas/cascade-renderers/footer-sections-area-cascade-renderer";
import { HeaderDesktopSectionCascadeRenderer } from "src/sections/renderers/cascade-renderers/header-desktop-cascade-renderer";
import { MeshSectionCascadeRenderer } from "src/sections/renderers/cascade-renderers/mesh-section-cascade-renderer";
import { FooterSectionCascadeRenderer } from "src/sections/renderers/cascade-renderers/footer-section-cascade-renderer";
import { MeshCascadeRenderer } from "src/mesh/renderers/cascade-renderers/mesh-cascade-renderer";
import { HeaderMobileSectionCascadeRenderer } from "src/sections/renderers/cascade-renderers/header-mobile-section-cascade-renderer";
import { MeshRowCascadeRenderer } from "src/mesh/renderers/cascade-renderers/mesh-row-cascade-renderer";
import { MeshColumnCascadeRenderer } from "src/mesh/renderers/cascade-renderers/mesh-column-cascade-renderer";
import { PopUpSectionCascadeRenderer } from "src/sections/renderers/cascade-renderers/pop-up-section-cascade-renderer";
import { PopUpCascadeRenderer } from "src/pop-up/cascade-renderers/pop-up-cascade-renderer";
import { BoxWidgetCascadeRenderer } from "src/widgets/cascade-renderers/box-widget-cascade-renderer";
import { IRenderingCommonContext } from "@commonRendering/types";
import { LiteHeaderSectionCascadeRenderer } from "src/sections/renderers/cascade-renderers/lite-header-section-cascade-renderer";
import { ErrorSectionCascadeRenderer } from "src/sections/renderers/cascade-renderers/error-section-cascade-renderer";

export class CascadeRendererFactory {

    public static create(type: ElementType, renderingCommonContext: IRenderingCommonContext): CascadeRendererBase<IElementData> {
        switch (type) {
            case "PopUp":
                return new PopUpCascadeRenderer(renderingCommonContext);
            case "HeaderSectionsArea":
                return new HeaderSectionsAreaCascadeRenderer(renderingCommonContext);
            case "LiteHeaderSection":
                return new LiteHeaderSectionCascadeRenderer(renderingCommonContext);
            case "MainSectionsArea":
                return new MainSectionsAreaCascadeRenderer(renderingCommonContext);
            case "FooterSectionsArea":
                return new FooterSectionsAreaCascadeRenderer(renderingCommonContext);
            case "HeaderDesktopSection":
                return new HeaderDesktopSectionCascadeRenderer(renderingCommonContext);
            case "HeaderMobileSection":
                return new HeaderMobileSectionCascadeRenderer(renderingCommonContext);
            case "MeshSection":
                return new MeshSectionCascadeRenderer(renderingCommonContext);
            case "FooterSection":
                return new FooterSectionCascadeRenderer(renderingCommonContext);
            case "PopUpSection":
                return new PopUpSectionCascadeRenderer(renderingCommonContext);
            case "ErrorSection":
                return new ErrorSectionCascadeRenderer(renderingCommonContext);
            case "Mesh":
                return new MeshCascadeRenderer(renderingCommonContext);
            case "MeshRow":
                return new MeshRowCascadeRenderer(renderingCommonContext);
            case "MeshColumn":
                return new MeshColumnCascadeRenderer(renderingCommonContext);
            case "BoxWidget":
                return new BoxWidgetCascadeRenderer(renderingCommonContext);
            default:
                throw new Error(`Element type ${type} is not supported`);
        }
    }

}
